import React from 'react';

import { useCurrentTheme } from 'app/shared/theme';
import { Box } from 'app/shared/components/atoms';
import { ItemTagProps } from 'app/fan/components/molecules/ItemTag';

import { CardContents } from './CardContents';

export interface CompactItemCardProps {
  backgroundColor?: string;
  hoverBackgroundColor?: string;
  title: string;
  bodyText?: string | React.ReactElement;
  dateMonth?: string; // e.g. 'Jan'
  dateDay?: string; // e.g. '6'
  dateWeekday?: string; // e.g. 'Sat'
  itemTagsProps?: ItemTagProps[];
  showArrowButton?: boolean;
}

export const CompactItemCard: React.FC<
  React.PropsWithChildren<CompactItemCardProps>
> = ({
  backgroundColor,
  hoverBackgroundColor,
  title,
  bodyText,
  dateMonth,
  dateDay,
  dateWeekday,
  itemTagsProps,
  showArrowButton = true,
  children,
}) => {
  const { borderRadius, colors } = useCurrentTheme();
  const cardBackgroundColor = backgroundColor || colors.primary.white.base;
  const cardHoverBackgroundColor =
    hoverBackgroundColor || colors.primary.white.lightest;

  return (
    <Box
      w="100%"
      minWidth="295px"
      borderRadius={borderRadius.card}
      backgroundColor={cardBackgroundColor}
      hoverBackgroundColor={cardHoverBackgroundColor}
      flexDirection="column"
      justifyContent="space-between"
      alignItems="center"
      cursor="pointer"
      data-qaid="compact-item-card"
    >
      <Box
        h="100%"
        w="100%"
        borderRadius={borderRadius.card}
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <CardContents
          bodyText={bodyText}
          itemTagsProps={itemTagsProps}
          title={title}
          dateMonth={dateMonth}
          dateDay={dateDay}
          dateWeekday={dateWeekday}
          showArrowButton={showArrowButton}
          isBottomOfCard={!children}
        />
      </Box>
      {children}
    </Box>
  );
};
